import { z } from "zod";

const zSchema = z.object({
  id: z.number().int(),
  fileName: z.string(),
  contentType: z.string(),
  uploadedAt: z.date(),
});
type Schema = z.infer<typeof zSchema>;

export { zSchema };
export type { Schema };
